import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'parseSuper', standalone: true })
export class ParseSuperPipe implements PipeTransform {
  transform(line: string): string {
    return line.replace('®', '<sup>®</sup>');
  }
}
